import SimpleLightbox from "simplelightbox";
// import 'simplelightbox/dist/simple-lightbox.min.css';

let gallery = new SimpleLightbox('.certificates__list a', {
  showCounter: false,
  spinner: false,
  widthRatio: 0.9,
});